var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutgoingLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1036 0.5H13.25C13.3881 0.5 13.5 0.61193 13.5 0.75V4.89645C13.5 5.11917 13.2307 5.23072 13.0732 5.07322L11.5303 3.53033L7.78033 7.28033C7.48744 7.57322 7.01256 7.57322 6.71967 7.28033C6.42678 6.98744 6.42678 6.51256 6.71967 6.21967L10.4697 2.46967L8.9268 0.92678C8.7693 0.76929 8.8808 0.5 9.1036 0.5ZM2.25 1.5C1.2835 1.5 0.5 2.2835 0.5 3.25V11.75C0.5 12.7165 1.2835 13.5 2.25 13.5H10.75C11.7165 13.5 12.5 12.7165 12.5 11.75V8.25C12.5 7.83579 12.1642 7.5 11.75 7.5C11.3358 7.5 11 7.83579 11 8.25V11.75C11 11.8881 10.8881 12 10.75 12H2.25C2.11193 12 2 11.8881 2 11.75V3.25C2 3.11193 2.11193 3 2.25 3H5.75C6.16421 3 6.5 2.66421 6.5 2.25C6.5 1.83579 6.16421 1.5 5.75 1.5H2.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingLink);
export default __webpack_public_path__ + "static/media/outgoingLink.708671f79303a94a13c5c52b0509ac61.svg";
export { ForwardRef as ReactComponent };